"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMSService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class SendSMSService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.smsUrl = '/rest-api/notification/v1/sendsms/';
    }
    sendSMS(mobileNumber, message) {
        const inputArgs = new http_1.HttpParams().set('message', message);
        let queryParams = '?';
        for (const num of mobileNumber) {
            queryParams += 'phoneNumber=' + num + '&';
        }
        queryParams = queryParams.slice(0, -1);
        return this.post(this.smsUrl + queryParams, inputArgs).pipe(operators_1.map((data) => data));
    }
}
exports.SendSMSService = SendSMSService;
//# sourceMappingURL=sendsms.service.js.map